// src/constants/userRequestConstants.ts

// Action buttons configuration for user requests
export const userRequestButtonsConfig = {
  Pending: (requestType: string) => {
    if (requestType === "passwordReset") {
      return [
        { variant: "success", action: "approve", label: "Approve" },
        { variant: "danger", action: "delete", label: "Delete" },
      ];
    }
    return [
      { variant: "success", action: "approve", label: "Approve" },
      { variant: "danger", action: "reject", label: "Reject" },
      { variant: "danger", action: "delete", label: "Delete" },
    ];
  },
  Approved: [
    { variant: "primary", action: "complete", label: "Complete" },
    { variant: "danger", action: "delete", label: "Delete" },
  ],
  Rejected: [
    { variant: "success", action: "approve", label: "Approve" },
    { variant: "danger", action: "delete", label: "Delete" },
  ],
  Completed: [{ variant: "danger", action: "delete", label: "Delete" }],
  All: [
    { variant: "success", action: "approve", label: "Approve" },
    { variant: "danger", action: "reject", label: "Reject" },
    { variant: "danger", action: "delete", label: "Delete" },
  ],
};

// Status variants for badges
export const userRequestStatusVariants = {
  approved: "success",
  rejected: "danger",
  pending: "warning",
  complete: "primary",
  completed: "primary",
  default: "neutral",
};

// Display status mappings
export const userRequestStatusMessages = {
  approved: "Approved",
  rejected: "Rejected",
  pending: "Pending",
  complete: "Completed",
  completed: "Completed",
};
